import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useSuperAdminAuth } from '../../contexts/SuperAdminAuthContext';
import { Menu, Bell, Search } from 'lucide-react';

const Header = ({ onMenuClick }) => {
  const { superAdmin } = useSuperAdminAuth();
  const navigate = useNavigate();

  return (
    <header className="bg-white border-b border-gray-200 px-6 py-4">
      <div className="flex items-center justify-between">
        {/* Left: Menu & Search */}
        <div className="flex items-center gap-4">
          <button
            onClick={onMenuClick}
            className="p-2 hover:bg-gray-100 rounded-lg transition-colors"
          >
            <Menu className="h-5 w-5 text-gray-600" />
          </button>

          <div className="relative hidden md:block">
            <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 h-5 w-5 text-gray-400" />
            <input
              type="text"
              placeholder="Search..."
              className="pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-transparent w-64"
            />
          </div>
        </div>

        {/* Right: Notifications & User */}
        <div className="flex items-center gap-4">
          {/* Notices: opens the authoritative Status & Updates centre. No hardcoded unread dot — a false
              indicator is misleading; a real unread signal can be wired to this control when available. */}
          <button
            type="button"
            onClick={() => navigate('/superadmin-portal/dashboard/status-updates')}
            title="Status & Updates"
            aria-label="Status & Updates"
            className="p-2 hover:bg-gray-100 rounded-lg transition-colors relative"
          >
            <Bell className="h-5 w-5 text-gray-600" />
          </button>

          <div className="flex items-center gap-3 px-3 py-2 bg-gray-50 rounded-lg">
            <div className="w-8 h-8 bg-purple-600 rounded-full flex items-center justify-center text-white font-bold text-sm">
              {superAdmin?.email?.charAt(0).toUpperCase()}
            </div>
            <div className="hidden md:block">
              <p className="text-sm font-medium text-gray-900">
                {superAdmin?.email}
              </p>
              <p className="text-xs text-gray-500">Super Admin</p>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
